/**
 * Created by PanJiaChen on 16/11/18.
 */

/**
 * @param {string} path
 * @returns {Boolean}
 */
export function isExternal(path) {
  return /^(https?:|mailto:|tel:)/.test(path)
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function validUsername(str) {
  const valid_map = ['admin', 'editor']
  return valid_map.indexOf(str.trim()) >= 0
}


export function judgePhone (val) {
  if (!val) return ''
  let reg = /^(.{3}).*(.{4})$/
  return val.replace(reg, '$1****$2')
}



// WEBPACK FOOTER //
// ./src/utils/validate.js